export default __webpack_public_path__ + "static/media/job-post-logo.a2b94690.svg";